var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasicIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_Basic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "13.2103863%",
    x2: "78.7447867%",
    y2: "86.2935911%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7405",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10_Chapter_page",
    transform: "translate(-504.000000, -398.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    transform: "translate(490.000000, 343.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Readiness",
    transform: "translate(0.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_Basic",
    transform: "translate(12.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.836364, 2.509091)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#005DCC",
    x: 6.32727273,
    y: 0.245454545,
    width: 10.9090909,
    height: 11.1272727,
    rx: 0.436363636
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    x: 6.76363636,
    y: 0.0272727273,
    width: 10.9090909,
    height: 10.9090909,
    rx: 0.436363636
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#005DCC",
    cx: 5.61818182,
    cy: 9.79090909,
    r: 5.61818182
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1074866,6.73335559 L18.8727273,19.4181818 L4.90909091,19.4181818 L11.6743316,6.73335559 C11.7381249,6.61374313 11.8868046,6.56849276 12.0064171,6.63228608 C12.0493873,6.65520354 12.0845692,6.69038535 12.1074866,6.73335559 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-2)"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicIcon);
export default __webpack_public_path__ + "static/media/basic-icon.8f7e12c5d0c75d2a2aed8d511b1223f3.svg";
export { ForwardRef as ReactComponent };